/**
 * <ModalContent />
 *
 * @parent Modal 
 * @stateless
 */

//
// 
//
//
//
//
//

import React, { PropTypes } from 'react';
import StudentTable from './table/Student';
import AttendanceTable from './table/Attendance';
import FinanceTable from './table/Finance';

class ModalContent extends React.Component {
  constructor(props){
    super(props)

    this.state = {
    }
  }
  render() {
    return (
      <div className='export-modal-content'>
        { this.props.type === 'attendance' && <AttendanceTable {...this.props} /> }
        { this.props.type === 'student' && <StudentTable {...this.props} />}
        { this.props.type === 'finance' && <FinanceTable {...this.props} />}
      </div>
    )
  }
}

export default ModalContent;



// WEBPACK FOOTER //
// ./src/template/Modals/Export/ModalContent.js